import { QueryClient } from 'react-query';
import { DehydratedState, dehydrate, hydrate } from 'react-query/hydration';

import localForage from '../localForage';

const QUERY_STORAGE_KEY = `WebCheckinQuery-${process.env.REACT_APP_STAGE}`;

const throttle = <TArgs extends any[]>(func: (...args: TArgs) => any, wait = 100) => {
  let timer: NodeJS.Timeout | null = null;

  return (...args: TArgs) => {
    if (timer === null) {
      timer = setTimeout(() => {
        func(...args);
        timer = null;
      }, wait);
    }
  };
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: () => {},
      cacheTime: Infinity
    }
  }
});

export const hydrateQueryClientStateWithDataFromLocalForage = async () => {
  const existingQueryClientState = await localForage.getItem<DehydratedState>(QUERY_STORAGE_KEY);

  if (existingQueryClientState) {
    hydrate(queryClient, existingQueryClientState);
  }
};

const storeStateToLocalForage = throttle(() => {
  localForage.setItem(QUERY_STORAGE_KEY, dehydrate(queryClient));
}, 1000);

queryClient.getQueryCache().subscribe(() => {
  storeStateToLocalForage();
});

export default queryClient;
